import { ReactNode } from 'react';

type AnimatedListProps = {
  children: ReactNode[];
  delayBetweenItems?: number;
  className?: string;
};

export const AnimatedList = ({
  children,
  delayBetweenItems = 100,
  className = 'flex flex-col gap-4'
}: AnimatedListProps) => {
  return (
    <div className={className}>
      {children.map((child, index) => (
        <div
          key={index}
          className='animate-in duration-500 fade-in-0 slide-in-from-bottom-4'
          style={{
            animationDelay: `${index * delayBetweenItems}ms`,
            animationFillMode: 'both'
          }}
        >
          {child}
        </div>
      ))}
    </div>
  );
};
